import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppKitProvider } from './services/walletConnect/web3ModalProvider';
import { Buffer } from "buffer";
import process from "process";
//import { CartProvider } from './components/shopping/cart/CartContext';

// Ensure polyfills are available globally
if (typeof global !== "undefined") {
  (global as any).Buffer = Buffer;
  (global as any).process = process;
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <AppKitProvider>
      <BrowserRouter>
        <App />
        {/*<CartProvider>
        </CartProvider>*/}
      </BrowserRouter>
    </AppKitProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
